// A blank release is omitted so the SDK keeps its build-injected release.
export function browserSentryOptions(input) {
    const { release, ...rest } = input;
    const trimmed = release.trim();
    return trimmed ? { ...rest, release: trimmed } : rest;
}
//# sourceMappingURL=BrowserSentryOptions.js.map